<template>
    <div class="noFound">
        <p v-if="message">{{message}}</p>
        <p v-if="!message">Not Found!</p>
    </div>
</template>

<script>
    export default {
        name: 'NoContent',
        props: ['message'],
        data () {
            return {
                msg: 'Welcome to Your Vue.js App'
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/include/NoContent.vue